import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFinderFace: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="finder-face"><path d="M7 7V10" stroke="currentColor" strokeWidth="1.5"/><path d="M17 7V10" stroke="currentColor" strokeWidth="1.5"/><path d="M14 2C12.16 5.87015 10.8443 8.79922 10 13H13C12.4417 16.0502 12.4417 18.9498 13 22" stroke="currentColor" strokeWidth="1.5"/><path d="M5 16C9.78201 19.5635 14.218 19.5635 19 16" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFinderFace;
